// extracted by mini-css-extract-plugin
export default {"default":"qEiBv","slogan":"iMRRV","title":"k3ME7","fadeSlideIn":"GdDCX","subtitle":"qnDPe"};